import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getItemRendered } from '../../../api/items';

import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const fetchItemRendered = createAsyncThunk(
  'items/fetchItemRendered',
  async (itemData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getItemRendered(itemData, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const fetchItemRenderedExtraReducers = builder => {
  builder
    .addCase(fetchItemRendered.pending, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg);

      checkAndSetLoadingWithId(
        state.items.rendered.request,
        action,
        itemCIDKey,
      );
    })
    .addCase(fetchItemRendered.fulfilled, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg);

      onMatchedRequest(state.items.rendered.request[itemCIDKey], action, () => {
        state.items.rendered.byId[itemCIDKey] = action.payload;
      });
    })
    .addCase(fetchItemRendered.rejected, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg);

      handleRequestRejection(state.items.rendered.request[itemCIDKey], action);
    });
};
